import {
  GET_DASHBOARD_DATA_SUCCESS,
  GET_TRANSACTION_DATA_SUCCESS,
  GET_TRANSACTION_DATA,
  GET_AUM_DATA_SUCCESS,
  GET_FREQUENT_MAIL_BACK_REQUEST_SUCCESS,
  GET_DASHBOARD_AUM_DATA_SUCCESS,
  GET_SIP_SUMMARY_DATA_SUCCESS,
  GET_NFO_SCHEMES_SUCCESS,
  GET_NFO_SCHEMES,
} from "../types";

export function dashboard(
  state = { summaryData: [], aumData: [], nfoSchemes: [] },
  action
) {
  switch (action.type) {
    case GET_DASHBOARD_DATA_SUCCESS: {
      const { DtData } = action.body;
      const [data] = DtData;

      return { ...state, transactionSummary: data };
    }
    case GET_DASHBOARD_AUM_DATA_SUCCESS: {
      return { ...state, dashboardAUMData: action.body };
    }
    case GET_SIP_SUMMARY_DATA_SUCCESS: {
      return { ...state, sipSummaryData: action.body };
    }
    case GET_TRANSACTION_DATA: {
      return { ...state, summaryData: [] };
    }
    case GET_NFO_SCHEMES_SUCCESS: {
      return { ...state, nfoSchemes: action.body };
    }

    case GET_TRANSACTION_DATA_SUCCESS: {
      const { DtData } = action.body;
      return { ...state, summaryData: DtData };
    }
    case GET_AUM_DATA_SUCCESS: {
      const {
        DtData: aumData,
        Table2: fundData,
        Table3: [data],
      } = action.body;
      return {
        ...state,
        aumData: aumData.map((item) => ({
          name: item.category,
          value: item.aum,
        })),
        fundData: fundData
          .sort(function (a, b) {
            return b.aum_percent - a.aum_percent;
          })
          .slice(0, 5)
          .map((item) => ({
            name: item.fund,
            value: item.aum_percent,
          })),
        totalAum: action.body.Table2.map((item) => ({
          aum: item.aum,
        })).reduce((p, c) => p + parseFloat(c.aum), 0),
        my_aum: data.my_aum,
        numberofschemes: data.Numberofschemes,
      };
    }
    case GET_FREQUENT_MAIL_BACK_REQUEST_SUCCESS: {
      return state;
    }
    default:
      return state;
  }
}
